/** @format */

import PropTypes from 'prop-types';
// import { Dialog } from "@mui/material";
// import { styled } from "@mui/material/styles";
import parse from 'html-react-parser';
import { format } from '@flasd/whatsapp-formatting';
// import BootstrapDialogTitle from "./BootstrapDialogTitle";
import React from 'react';

import playButton from '../assets/play.png';
import sampleImage from '../assets/sampleimg.png';
import cameraIcon from '../assets/camerapng.png';
import pdfIcon from '../assets/pdficon.png';
import { HiOutlineExternalLink, HiPhone } from 'react-icons/hi';

WAPreviewBody.propTypes = {
  content: PropTypes.string,
  footer: PropTypes.string,
  headerFormat: PropTypes.string,
  headerImage: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

const classes = {
  message: {
    color: '#000',
    clear: 'both',
    lineHeight: '18px',
    fontSize: '15px',
    padding: '8px',
    position: 'relative',
    margin: '8px 0',
    maxWidth: '85%',
    wordWrap: 'break-word',
    background: '#fff',
    borderRadius: '0px 7px 7px 7px',
    float: 'left',
    display: 'flex',
    flexDirection: 'column',
  },
  afterMessage: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0px 10px 10px 0',
    borderColor: 'transparent #fff transparent transparent',
    top: 0,
    left: '-10px',
  },
  metadata: {
    display: 'inline-block',
    float: 'right',
    alignSelf: 'flex-end',
    padding: '0 0 0 16px',
    position: 'relative',
    bottom: '-4px',
    color: 'rgba(0, 0, 0, .45)',
    fontSize: '11px',
  },
  footer: {
    color: 'rgba(0, 0, 0, .45)',
  },
  header: {
    fontWeight: 'bold',
  },
  videoMeta: {
    position: 'absolute',
    bottom: 0,
    color: 'white',
    zIndex: 10,
    fontSize: '10px',
    marginLeft: '5px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    color: '#48a5ee',
    clear: 'both',
    lineHeight: '18px',
    fontSize: '15px',
    padding: '8px',
    position: 'relative',
    margin: '8px 0',
    marginTop: '-4px',
    maxWidth: '85%',
    wordWrap: 'break-word',
    background: '#fff',
    borderRadius: '0px 7px 7px 7px',
    float: 'left',
    textAlign: 'center',
  },
  urlButton: {
    color: '#48a5ee',
    clear: 'both',
    lineHeight: '18px',
    fontSize: '15px',
    padding: '8px',
    position: 'relative',
    wordWrap: 'break-word',
    background: '#fff',
    float: 'left',
    textAlign: 'center',
  },
  urlButtonLine: {
    lineHeight: '18px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
  },
};

// const BootstrapDialog = styled(Dialog)(({theme}) => ({
//     '& .MuiDialogContent-root': {
//         width: 400,
//         minHeight: 300,
//     },
//     '& .MuiDialogActions-root': {
//         padding: theme.spacing(1),
//     },
// }));

export default function WAPreviewBody({
  content,
  open,
  footer,
  header,
  headerFormat,
  headerImage,
  buttonType,
  buttonQuickReply,
  buttonPhoneNumberURL,
}) {
  console.log('headerImage', headerImage);
  return (
    <div>
      <div
        style={{
          ...classes.message,
          width: '100%',
        }}
      >
        {headerFormat === 'DOCUMENT' ? (
          <>
            <div
              style={{
                background: '#f8f8f8',
                display: 'flex',
                flexDirection: 'row',
                height: 36,
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <img
                style={{
                  marginBottom: 5,
                  objectFit: 'contain',
                  height: 30,
                  width: 26,
                }}
                alt={'img-1'}
                src={pdfIcon}
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginLeft: 10,
                }}
              >
                <div>doc.pdf</div>
                <div
                  style={{
                    ...classes.footer,
                    fontSize: 12,
                  }}
                >
                  17 MB • PDF
                </div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}

        {headerFormat === 'IMAGE' ? (
          <>
            <img
              style={{
                width: '100%',
                marginBottom: 5,
                objectFit: 'contain',
              }}
              alt={'img-2'}
              src={headerImage ?? sampleImage}
            />
          </>
        ) : (
          ''
        )}

        {headerFormat === 'VIDEO' ? (
          <>
            <div
              style={{
                display: 'block',
                background: 'black',
                height: 150,
                width: '100%',
                marginBottom: 5,
                position: 'relative',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  style={{ width: 32, height: 32 }}
                  src={playButton}
                  alt="video"
                />
              </div>
              <p style={{ ...classes.videoMeta }}>
                <img src={cameraIcon} alt={'img-3'} />
                &nbsp;&nbsp;1:23
              </p>
            </div>
          </>
        ) : (
          ''
        )}

        <span>
          {headerFormat === 'TEXT' && header ? (
            <>
              <span style={{ ...classes.header }}>{header}</span>
              <br />
              <br />
            </>
          ) : (
            ''
          )}

          {content?.length > 0
            ? parse(format(content))
            : 'Please fill in the body field.'}

          {footer ? (
            <>
              <br />
              <br />
              <span style={{ ...classes.footer }}>{footer}</span>
            </>
          ) : (
            ''
          )}
        </span>

        <span style={{ ...classes.metadata }}>9:10 AM</span>

        {/*<hr/>*/}

        <span style={{ ...classes.afterMessage }} />

        {buttonType === 'PHONE_NUMBER_URL' && (
          <div
            style={{
              ...classes.urlButton,
              display: 'flex',
              flexDirection: 'column',
              borderTop: '0.5px solid #cfcfcf',
              marginTop: 10,
              paddingTop: 10,
            }}
          >
            {buttonPhoneNumberURL.map((obj, key) => {
              if (!obj.text) {
                return <></>;
              }
              return (
                <div
                  key={key}
                  style={{
                    ...classes.urlButtonLine,
                    marginTop: key > 0 ? 18 : null,
                  }}
                >
                  {obj.type === 'URL' ? (
                    <HiOutlineExternalLink size={15} />
                  ) : (
                    <HiPhone size={15} />
                  )}
                  &nbsp;{obj.text}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {buttonType === 'QUICK_REPLY' &&
        buttonQuickReply.map((obj, key) => {
          if (!obj.text) {
            return <></>;
          }
          return (
            <div
              key={key}
              style={{
                ...classes.button,
                width: '85%',
              }}
            >
              {obj.text}
            </div>
          );
        })}

      {/*<div style={{*/}
      {/*  width: "85%",*/}
      {/*  display : "flex",*/}
      {/*  flexDirection : "row"*/}
      {/*}}>*/}
      {/*  <div style={{*/}
      {/*    ...classes.button,*/}
      {/*    width: "50%",*/}
      {/*  }}>*/}
      {/*    Option 1*/}
      {/*  </div>*/}

      {/*  <div style={{*/}
      {/*    ...classes.button,*/}
      {/*    width: "50%",*/}
      {/*    marginLeft : 3*/}
      {/*  }}>*/}
      {/*    Option 2*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
}
